
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import years from "../years";
import { ILive } from "../@types/interface.d";

interface DataType {
  lives: ILive[];
  sortCol: string;
  sortAsc: boolean;
  years: number[];
  currentYear: number;
}

interface MethodType {
  init: () => void;
  sort: () => void;
}

interface ComputedType {
  sorted: ILive[];
}

export default Vue.extend({
  name: "lives",
  components: {
    Headline,
    Breadcrumb,
    BreadcrumbItem,
  },
  data(): DataType {
    return {
      lives: [],
      sortCol: "id",
      sortAsc: true,
      years,
      currentYear: new Date().getFullYear(),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      fetch(`/api/lives/${this.currentYear}`).then(res => res.json()).then((data: ILive[]) => {
        this.lives = data.map((v, idx) => {
          v.id = idx + 1;
          return v;
        });
      });
    },
    sort(col: string) {
      this.sortCol = col;
      this.sortAsc = !this.sortAsc;
    },
    badgeClass(year: number): string {
      return year === this.currentYear ? "badge-primary" : "badge-secondary";
    },
    yearClick(year: number): void {
      this.currentYear = year;
      this.init();
    },
  },
  computed: {
    sorted() {
      let list: ILive[] = this.lives.concat([]);
      switch (this.sortCol) {
        case "id":
          break;
        case "title":
          list = list.sort((a, b) => a.title < b.title ? -1 : 1);
          break;
        case "count":
          list = list.sort((a, b) => a.songCount - b.songCount);
          break;
        case "date":
          list = list.sort((a, b) => a.date < b.date ? -1 : 1);
          break;
        default:
          break;
      }
      return this.sortAsc ? list : list.reverse();
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
